module.exports = __webpack_public_path__ + "img/questionnaires.a837e004.svg";